<script>
import TabNav from './tab-nav'
export default {
  components: {
    TabNav
  },
  props: {
    value: {},
    activeName: String
  },
  provide() {
    return {
      rootTabs: this
    }
  },
  data() {
    return {
      currentName: this.value || this.activeName || '0',
      panes: []
    }
  },
  created() {
    this.$on('tab-nav-update', this.calcPaneInstances)
  },
  mounted() {
    this.calcPaneInstances()
    window.tab = this
  },
  updated() {
    this.calcPaneInstances()
  },
  methods: {
    calcPaneInstances() {
      if (this.$slots.default) {
        const panelSlots = this.$slots.default.filter(
          (vnode) =>
            vnode.tag &&
            vnode.componentOptions &&
            vnode.componentOptions.Ctor.options.name === 'CPTabPane'
        )
        const panes = panelSlots.map(
          ({ componentInstance }) => componentInstance
        )
        const panesChanged = !(
          panes.length === this.panes.length &&
          panes.every((panel, index) => panel === this.panes[index])
        )
        if (panesChanged) {
          this.panes = panes
        }
      } else if (this.panes.length !== 0) {
        this.panes = []
      }
    },
    setCurrentName(value) {
      this.currentName = value
      this.$emit('input', value)
    },
    handleTabClick(value) {
      this.setCurrentName(value)
      this.$emit('tab-click', value)
    }
  },
  render() {
    const navData = {
      props: {
        panes: this.panes,
        curName: this.currentName,
        onTabClick: this.handleTabClick
      }
    }
    return (
      <div class="cp-tabs">
        <tab-nav {...navData} />
        <div class="cp-tabs_content">{this.$slots.default}</div>
      </div>
    )
  }
}
</script>
